import InputLabel from "@/components/atomic/atoms/InputLabel";
import SearchSelectResult from "@/components/atomic/molecules/SearchSelectResult";
import { PV_SELECT_OPTION } from "@/types/PresenterModel/PV_SELECT_OPTION";
import "./index.css";

type Props<T> = {
  labelText: string;
  inputKeyword: string;
  selectedItem: PV_SELECT_OPTION<T> | null;
  onInputKeywordChange: (v: string) => void;
  onSelect: (v: PV_SELECT_OPTION<T> | null) => void;
  list?: Array<PV_SELECT_OPTION<T>>;
  needClear?: boolean;
  selectorFontClass?: string;
  resultFontClass?: string;
  dataType: string;
  clearText?: string;
  showResult?: boolean;
  needDelete?: boolean;
  onDelete?: (v: PV_SELECT_OPTION<T> | null) => void;
  disabled?: boolean;
};

export default function SearchSelectControl<T = string>({
  labelText,
  inputKeyword,
  selectedItem,
  onInputKeywordChange,
  onSelect,
  list = [],
  needClear = false,
  selectorFontClass,
  resultFontClass,
  dataType,
  clearText = "전체",
  showResult,
  needDelete,
  onDelete,
  disabled
}: Props<T>) {
  return (
    <div className="atomic organisms search-select-control">
      <div className="label-box">
        <InputLabel labelText={labelText} />
      </div>
      <div className="search-condition-box">
        <SearchSelectResult<T>
          onDelete={onDelete}
          needDelete={needDelete}
          showResult={showResult}
          needClear={needClear}
          list={list}
          inputKeyword={inputKeyword}
          onInputKeywordChange={onInputKeywordChange}
          onSelect={onSelect}
          selectedItem={selectedItem}
          selectorFontClass={selectorFontClass}
          resultFontClass={resultFontClass}
          dataType={dataType}
          clearText={clearText}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
